module.exports = __webpack_public_path__ + "static/scan-f6468bd6b14af0038786b3884e7ac4ca.png";